export default __webpack_public_path__ + "static/media/pgmico(45).80cbbe81.png";